import { RequestGateway } from "../RequestGateway/RequestGateway";
export class PlatformRequestGateway extends RequestGateway {
    constructor(requestservice) {
        super(requestservice);
        this.token = "";
    }
    getExistingToken() {
        return this.token;
    }
    setToken(token) {
        this.token = token;
    }
    getToken() {
        const token = this.getExistingToken();
        if (token) {
            return Promise.resolve(token);
        }
        if (!this.anonymousPromise) {
            let ref = this;
            this.anonymousPromise = new Promise(function (resolve, reject) {
                ref.getAnonymousToken()
                    .then(token => {
                    resolve(token);
                })
                    .catch(err => {
                    ref.recursiveRenew(err, ref.getAnonymousToken.bind(ref), resolve, reject);
                });
            });
        }
        return this.anonymousPromise;
    }
}
//# sourceMappingURL=PlatformRequestGateway.js.map